var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurso17Gray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 474.2 474.2",
    style: {
      enableBackground: "new 0 0 474.2 474.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#808080;stroke-width:20.62;}\r\n\t.st1{fill:#808080;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_00000098912866840240644140000002869299118009589634_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 237.1,
    cy: 237.1,
    r: 226.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_442",
    className: "st0",
    d: "M355.5,127.5L311,305.8l-185.2,51.4l53.1-195.9L355.5,127.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.6,216.3c-14.4,0-26.1,11.7-26.1,26.1c0,14.4,11.7,26.1,26.1,26.1c14.4,0,26.1-11.7,26.1-26.1 c0,0,0,0,0,0C266.7,228,255.1,216.3,240.6,216.3 M240.6,195.7c25.8,0,46.7,20.9,46.7,46.7c0,25.8-20.9,46.7-46.7,46.7 c-25.8,0-46.7-20.9-46.7-46.7l0,0C193.9,216.6,214.9,195.7,240.6,195.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso17Gray);
export default __webpack_public_path__ + "static/media/Recurso_17gray.3d1fc64385c3571671fce2570bf09373.svg";
export { ForwardRef as ReactComponent };